import State from 'store/State';
import { selectStreamedDataState } from 'streamsState/store/streamedData/selectors';
import { buildStreamedDataStreamSlice } from 'streamsState/store/streamedData/streamSlice';

import { SymbolInfoDataMessage } from 'widgets/symbolInfo/SymbolInfoDataMessage';
import { SymbolInfoStreamStates } from 'widgets/symbolInfo/store/SymbolInfoWidgetState';
import { StreamState } from 'streamsState/store/streamedData/StreamedDataState';
import { StreamElementDataMessage } from 'communication/types/StreamElement';
import {
    createSymbolInfoRequestUid,
    createSymbolInfoWidgetRequestUid,
} from 'widgets/symbolInfo/SymbolInfoRequest';

export const processSymbolInfoDataStreamElement = (
    response: SymbolInfoDataMessage,
    nextState: SymbolInfoStreamStates
) => {
    return (nextState.data = response);
};

export const selectSymbolInfoStreamedData = (state: State) =>
    selectStreamedDataState(state).symbolInfo;

export function reduceSymbolInfoMessage(
    response: StreamElementDataMessage<SymbolInfoDataMessage>,
    state: StreamState<SymbolInfoDataMessage>
): StreamState<SymbolInfoDataMessage> {
    // SymbolInfo does not follow the usual stream convention: response is actually a SymbolInfoDataMessage
    state.data = fixEmptyData(response as SymbolInfoDataMessage);
    return state;
}

const buildSymbolInfoStreamSlice = () =>
    buildStreamedDataStreamSlice(
        'symbolInfo',
        { messages: [] },
        selectSymbolInfoStreamedData,
        createSymbolInfoWidgetRequestUid,
        createSymbolInfoRequestUid,
        processSymbolInfoDataStreamElement,
        reduceSymbolInfoMessage
    );

const {
    reducer: symbolInfoStreamedDataReducer,
    selectors: symbolInfoStreamedDataSelectors,
} = buildSymbolInfoStreamSlice();

export { symbolInfoStreamedDataReducer, symbolInfoStreamedDataSelectors };

function fixEmptyData(
    message: SymbolInfoDataMessage
): SymbolInfoDataMessage | undefined {
    if (message.country === 'N/A') {
        return undefined;
    }
    return message;
}
